import { makeStyles, Theme } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: 25,
    color: 'black',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  title: {
    minWidth: '180px',
    maxWidth: '200px',
    color: 'rgb(0 0 0 / 70%)',
    fontWeight: 600,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      textAlign: 'left',
    },
  },
  textFields: {
    flex: 1,
    width: '100%',
    fontSize: '16px',
  },
  textField: {
    flex: 1,
    width: '100%',
  },
  paper: {
    paddingTop: theme.spacing(1),
    padding: theme.spacing(3),
    width: '90%',
    maxWidth: '900px',
    height: 'auto',
    maxHeight: '90vh',
    overflowY: 'auto',
    borderRadius: '8px',
  },
  btn: {
    marginTop: theme.spacing(5),
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  blueText: {
    color: blue[700],
  },
  templateBodyKeywords: {
    color: blue[700],
  },
  keywordTitle: {
    margin: theme.spacing(4, 0, 0, 0),
  },
  keywords: {
    marginLeft: theme.spacing(2),
    color: blue[700],
  },
  contentEditable: {
    height: '150px',
    minHeight: '120px',
    maxHeight: '300px',
    overflowY: 'auto',
    width: '100%',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    whiteSpace: 'pre-wrap',
  },
}));
